// Growem — plan-pending gate. Rendered when profile.planStatus === 'pending'. Whole app stays
// gated; only escape is Cerrar sesión. Existing design-system classes only. No ETA copy.
// Polls plan_status (window focus + every 30 s) so the user moves into their plan without a manual
// reload when the team activates it (refreshPlanStatus runs the full load only on the ready flip).
import { useEffect } from 'react'
import { useStore } from '../state/store'

export default function Waiting() {
  const { profile, signOut, refreshPlanStatus } = useStore()

  useEffect(() => {
    const onFocus = () => { void refreshPlanStatus() }
    window.addEventListener('focus', onFocus)
    document.addEventListener('visibilitychange', onFocus)
    const iv = window.setInterval(onFocus, 30_000)
    return () => {
      window.removeEventListener('focus', onFocus)
      document.removeEventListener('visibilitychange', onFocus)
      window.clearInterval(iv)
    }
  }, [refreshPlanStatus])
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div className="disp pulseDot" style={{ fontWeight: 700, fontSize: 40 }}>
        growem<span style={{ color: 'var(--volt)' }}>.</span>
      </div>
      <div className="card" style={{ marginTop: 24, width: '100%', maxWidth: 360 }}>
        <div className="kick">plan en preparación</div>
        <div className="h1" style={{ marginTop: 6 }}>Ya casi{profile.displayName ? `, ${profile.displayName}` : ''}.</div>
        <p className="tip" style={{ marginTop: 10 }}>
          Tenemos todo lo que nos diste. Estamos armando tu plan a tu medida: tus días, tus metas y tu punto de partida.
        </p>
        <p className="note" style={{ marginTop: 12 }}>Tu plan aparecerá aquí solo cuando esté listo.</p>
        <p className="muted" style={{ fontSize: 12.5, marginTop: 8 }}>Puedes cerrar la app y volver más tarde; no tienes que hacer nada más.</p>
      </div>
      <button type="button" className="link" onClick={() => void signOut()}
              style={{ fontSize: 13, background: 'none', padding: 0, marginTop: 18, minHeight: 44 }}>
        Cerrar sesión
      </button>
    </div>
  )
}
